module.exports = __webpack_public_path__ + "img/switzerland-congenital-and-perinatal-diseases-male.35d84005.png";